module.exports = "../static/media/official.cb3f2b46.png";